import { render, staticRenderFns } from "./NotSetup.vue?vue&type=template&id=2354bd89&"
import script from "./NotSetup.vue?vue&type=script&lang=js&"
export * from "./NotSetup.vue?vue&type=script&lang=js&"
import style0 from "./NotSetup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports